/*
Blog Article Script
*/

  jQuery(document).ready(function( $ ){
     
  $('a[href^="#"]').click(function() {
      var target = $(this.hash);
      if (target.length == 0) target = $('a[name="' + this.hash.substr(1) + '"]');
      if (target.length == 0) target = $('html');
      $('html, body').animate({ scrollTop: target.offset().top-140 }, 1000);
      return false;
  });
  jQuery('.articleblogList .blog-posts').slick({
        rows: 2,
        arrows: true,
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: '<div class="slick-prev"><i class="fa fa-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="fa fa-chevron-right"></i></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
			  rows: 2,
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      });
  });
  
 



  document.addEventListener('DOMContentLoaded', function () {
    const stickyElement = document.getElementById('sticky-button');
    const stickySection = document.getElementById('article-section');
    const commentFormSection = document.getElementById('customerPromise');

    // Exit if any required element is missing
    if (!stickyElement || !stickySection || !commentFormSection) return;

    window.addEventListener('scroll', function () {
        const sectionTop = stickySection.getBoundingClientRect().top;
        const sectionBottom = stickySection.getBoundingClientRect().bottom;
        const commentFormTop = commentFormSection.getBoundingClientRect().top;

        if (sectionTop <= 0 && sectionBottom > 0 && commentFormTop >= window.innerHeight) {
            stickyElement.style.display = 'block';
        } else {
            stickyElement.style.display = 'none';
        }
    });
});



  

 document.addEventListener("DOMContentLoaded", function () {
    const tocList = document.getElementById("toc-list");
    const tocContainer = document.getElementById("table-of-content");
    const tocBtn = document.querySelector(".cus-btn-warning"); // use . for class
    const headings = document.querySelectorAll(".main-article-box h2");
    const header = document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;

    // Build TOC
    headings.forEach((heading, index) => {
        const id = `section-${index + 1}`;
        heading.id = id;

        const listItem = document.createElement("li");
        const link = document.createElement("a");
        link.href = `#${id}`;
        link.textContent = heading.textContent;

        link.addEventListener("click", function (event) {
            event.preventDefault();
            const target = document.querySelector(link.getAttribute("href"));
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: targetPosition - headerHeight,
                behavior: "smooth"
            });
        });

        listItem.appendChild(link);
        tocList.appendChild(listItem);
    });

    // Hide TOC and button if no headings
    if (headings.length === 0) {
        if (tocContainer) tocContainer.style.display = "none";
        if (tocBtn) tocBtn.style.display = "none";
    }
});


